import { useUpdateAdMutation } from '@api/api';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { MdOutlineCheckCircle } from 'react-icons/md';

export default function MarkAsReadyButton({ item }: { item: any }) {
  const t = useTranslations('newAd');
  const [patchAd, { isLoading }] = useUpdateAdMutation();
  const [updated, setUpdated] = useState(false);
  const [withError, setWithError] = useState(false);
  const markAsReady = (id: number) => {
    patchAd({
      id,
      body: {
        user_ready: 1,
      },
    })
      .unwrap()
      .then(() => {
        setUpdated(true);
        setWithError(false);
      })
      .catch(() => {
        setWithError(true);
      });
  };
  return (
    <>
      {!item.user_ready && !isLoading && !updated && (
        <button
          onClick={() => markAsReady(item.id)}
          className='mt-2 flex items-center justify-center gap-2 rounded-sm bg-brand px-6 py-4 font-semibold uppercase text-black hover:bg-white focus:bg-white'
        >
          <MdOutlineCheckCircle /> <span>{t('setAdAsReady')}</span>
        </button>
      )}
      {isLoading && <p className='mt-2 text-center'>{t('settingAsReady')}</p>}
      {(updated || !!item.user_ready) && (
        <p className='mt-2 text-center'>{t('setAsReady')}</p>
      )}
    </>
  );
}
